export default __webpack_public_path__ + "static/media/i2.fff43543.png";